/* eslint-disable max-len */
import React, { SVGProps } from 'react';

// Had to take directly from material-ui icons
// https://github.com/mui/material-ui/blob/b3645b3fd11dc26a06ea370a41b5bac1026c6792/packages/mui-icons-material/material-icons/close_24px.svg

type Props = Pick<SVGProps<SVGSVGElement>, 'width' | 'height'>;
const Close: React.FC<Props> = (props: Props) => {
  const { width, height } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    </svg>
  );
};

export default Close;
